<script>
    import { onDestroy } from 'svelte';
    import { auth } from '../firebase/firebase.config.js';

    // Store
    import {UserStore} from '../store';

    let authStatus;
    let fullName;

    let unsub = UserStore.subscribe(data => {
        fullName = data.fullName;
        authStatus = data.authStatus;
    })


    // Life-cycle Hooks

    onDestroy(() => {
        unsub();
    });

    const handleLogoutUser = (e) => {
        auth.signOut()
            .then(() => {
                auth.onAuthStateChanged(user => {
                    if(user) {
                        console.log('user still exists');
                    } else {
                        UserStore.update(currentUser => {
                            return {
                                authStatus: false
                            }
                        });
                    }
                });
            }).catch(err => {
                console.log('logout err', err);
            });
    };

</script>

<div class="row border-bottom">
    <div class={authStatus === true ? 'col pb-4 text-center d-flex justify-content-between' : 'col pb-4 text-center'}>
        <h1 class="font-weight-bold cursor-default">Domestic Munshi</h1>
        {#if authStatus === true}
            <div class="d-flex justify-content-end align-items-center">
                <p class="h4 font-weight-light text-warning mr-4 mb-0 border-bottom border-warning">{fullName}</p>
                <button class="btn btn-light btn-lg" on:click={handleLogoutUser}>
                    Logout
                </button>
            </div>
        {/if}
    </div>
</div>